import CardSeplag from "../../../components/CardSeplag";
import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { buscarCronogramasPorParametroExercicio } from "../../../service/Rag/Cronograma";
import {
  carregarArvoreRag,
  carregarArvoreRagPermissao,
  carregarArvoreRagComFiltro,
} from "../../../service/Rag/ArvoreRag";
import { handleShowModalLancamentos } from "./AuthtorizationLancamentoRag";

const RagLancamentos = () => {
  const user = useSelector((state) => state.userReducer.user);

  const [cDadosArvore, setCDadosArvore] = useState([]);
  const [cDadosExercicios, setCDadosExercicios] = useState([]);
  const [cDadosOrgaos, setCDadosOrgaos] = useState([]);
  const [cDadosUOs, setCDadosUOs] = useState([]);
  const [parametroExercicio, setParametroExercicio] = useState([]);

  const [exercicioSelecionado, setExercicioSelecionado] = useState();
  const [orgaoSelecionado, setOrgaoSelecionado] = useState([]);
  const [uoSelecionada, setUoSelecionada] = useState([]);
  const [cronograma, setCronograma] = useState();

  const [isMONRL_LANCAMENTO] = useState(buscarPerfil("MONRL_LANCAMENTO"));
  const [isMONRL_ADMIN_CENTRAL] = useState(buscarPerfil("MONRL_ADMIN_CENTRAL"));
  const [isMONRL_ADMIN_SETORIAL] = useState(buscarPerfil("MONRL_ADMIN_SETORIAL"));
  const [isMONRL_ANALISTA] = useState(buscarPerfil("MONRL_ANALISTA"));
  const [isMONRL_ACESSO_ORGAO_CONTROLE] = useState(buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE"));
  const filtroReducer = useSelector((state) => state.filtroReducer);
  const dispatch = useDispatch();
  const nomePagina = "Lancamentos RAG";

  let history = useHistory();

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  const carregarLancamentoSemFiltro = async () => {
    let cronograma;
    if (isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA || isMONRL_ACESSO_ORGAO_CONTROLE) {
      const resAdm = await carregarArvoreRag().then((resAdm) => {
        montarArvore(resAdm);
        setExercicioSelecionado(resAdm.parametroExercicio.exercicio);
        setParametroExercicio(resAdm.parametroExercicio);
        setOrgaoSelecionado(resAdm.orgaoFiplans[0]);
        setUoSelecionada(resAdm.unidadeOrcamentarias[0]);
        carregarCronogramas(resAdm.parametroExercicio.idenParametroExercicio);
        return resAdm;
      });

      cronograma = await carregarCronogramas(resAdm.parametroExercicio.idenParametroExercicio);
      saveHistoryFilter({
        parametroExercicio: resAdm.parametroExercicio,
        exercicioSelecionado: resAdm.parametroExercicio.exercicio,
        orgaoSelecionado: resAdm.orgaoFiplans[0],
        uoSelecionada: resAdm.unidadeOrcamentarias[0],
        cronograma: cronograma,
        cDadosExercicios: resAdm != null ? resAdm.listaExercicios : null,
        cDadosOrgaos: resAdm != null ? resAdm.orgaoFiplans : null,
        cDadosUOs: resAdm != null ? resAdm.unidadeOrcamentarias : null,
        cDadosArvore:
          resAdm.arvorePtaMonitoras != null
            ? resAdm.arvorePtaMonitoras
            : { content: { key: null, statusItem: null, tipoItem: null } },
      });
    } else {
      await carregarArvoreRagPermissao().then((resPermissao) => {
        montarArvore(resPermissao);
        setExercicioSelecionado(resPermissao.listaExercicios[0]);
        setParametroExercicio(resPermissao.parametroExercicio);
        setOrgaoSelecionado(resPermissao.orgaoFiplans[0]);
        setUoSelecionada(resPermissao.unidadeOrcamentarias[0]);
        carregarCronogramas(resPermissao.parametroExercicio.idenParametroExercicio);
      });
    }
  };

  const carregarLancamentoComFiltro = async ({ idenExercicio, idenOrgao, idenUo }) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;

    await carregarArvoreRag().then((resAdm) => {
      setCDadosExercicios(resAdm != null ? resAdm.listaExercicios : null);
    });
    await carregarArvoreRagComFiltro(
      {
        idenExercicio: idenExercicio,
        idenOrgao: null,
        idenUo: null,
        idenPrograma: null,
      },
      defaultArvoreRag,
      buscarArvoreGeral
    ).then((res) => {
      setParametroExercicio(res.parametroExercicio);
      carregarCronogramas(res.parametroExercicio.idenParametroExercicio);

      setCDadosOrgaos(res != null ? res.orgaoFiplans : null);
    });

    await carregarArvoreRagComFiltro(
      {
        idenExercicio: idenExercicio,
        idenOrgao: idenOrgao,
        idenUo: null,
        idenPrograma: null,
      },
      defaultArvoreRag,
      buscarArvoreGeral
    ).then((res) => {
      setCDadosUOs(res != null ? res.unidadeOrcamentarias : null);
    });

    await carregarArvoreRagComFiltro(
      {
        idenExercicio: idenExercicio,
        idenOrgao: idenOrgao,
        idenUo: idenUo,
        idenPrograma: null,
      },
      defaultArvoreRag,
      buscarArvoreGeral
    ).then((dadosArvore) => {
      if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
        setCDadosArvore(dadosArvore.arvorePtaMonitoras);
      } else {
        setCDadosArvore({ content: { key: null, statusItem: null, tipoItem: null } });
        setParametroExercicio([]);
      }
    });
  };

  async function carregarCronogramas(idenParametroExercicio) {
    if (idenParametroExercicio) {
      return await buscarCronogramasPorParametroExercicio(idenParametroExercicio).then((res) => {
        setCronograma(res.data);
        return res.data;
      });
    }
  }

  let defaultArvoreRag = {
    arvorePtaMonitoras: cDadosArvore,
    listaExercicios: cDadosExercicios,
    parametroExercicio: parametroExercicio,
    orgaoFiplans: cDadosOrgaos,
    unidadeOrcamentarias: cDadosUOs,
  };

  function montarArvore(dadosArvore) {
    if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
      setCDadosArvore(dadosArvore.arvorePtaMonitoras);
      setParametroExercicio(dadosArvore.parametroExercicio);
      carregarCronogramas(dadosArvore.parametroExercicio.idenParametroExercicio);
    } else {
      setCDadosArvore({ content: { key: null, statusItem: null, tipoItem: null } });
      setParametroExercicio([]);
    }
    setCDadosExercicios(dadosArvore != null ? dadosArvore.listaExercicios : null);
    setCDadosOrgaos(dadosArvore != null ? dadosArvore.orgaoFiplans : null);
    setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
  }

  const acoesTemplate = (node, column) => {
    return (
      <>
        <Button
          type="button"
          icon="pi pi-cog"
          className="p-button-success Raised"
          style={{ marginRight: ".5em" }}
          onClick={() =>
            handleShowModalLancamentos(
              node,
              cronograma,
              user,
              parametroExercicio,
              history,
              isMONRL_LANCAMENTO,
              isMONRL_ADMIN_CENTRAL,
              isMONRL_ADMIN_SETORIAL,
              isMONRL_ANALISTA
            )
          }
        ></Button>
      </>
    );
  };

  // function handleShowModalLancamentos(data) {
  //   /* VERIFICAÇÕES DE HABILITAÇÃO DA AVALIAÇÃO */
  //   let podeAvaliarPrograma =
  //     (cronograma.programa.avaliacao && data.permissaoItem !== null && data.permissaoItem === "E") ||
  //     (cronograma.programa.avaliacao &&
  //       data.idenPessoaResp !== null &&
  //       data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
  //     (data.isProrrogaAvaliacao === "S" &&
  //       data.idenPessoaResp !== null &&
  //       data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
  //     (data.isProrrogaAvaliacao === "S" && data.permissaoItem !== null && data.permissaoItem === "E");

  //   let podeAvaliarIndicador =
  //     //  (cronograma.indicador.avaliacao && data.permissaoItem !== null && data.permissaoItem === "E") ||
  //     cronograma.indicador.avaliacao &&
  //     data.idenPessoaResp !== null &&
  //     data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa;

  //   let podeAvaliarAcao =
  //     (cronograma.acao.avaliacao && data.permissaoItem !== null && data.permissaoItem === "E") ||
  //     (cronograma.acao.avaliacao &&
  //       data.idenPessoaResp !== null &&
  //       data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
  //     (data.isProrrogaAvaliacao === "S" &&
  //       data.idenPessoaResp !== null &&
  //       data.idenPessoaResp === user.contaAcesso.pessoa.idenPessoa) ||
  //     (data.isProrrogaAvaliacao === "S" && data.permissaoItem !== null && data.permissaoItem === "E");

  //   /* VERIFICAÇÕES DE HABILITAÇÃO DAS ANÁLISES */
  //   let podeAnalisarPrograma =
  //     cronograma.programa.analise &&
  //     (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);
  //   let podeAnalisarIndicador =
  //     cronograma.indicador.analise &&
  //     (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);
  //   let podeAnalisarAcao =
  //     cronograma.acao.analise &&
  //     (isMONRL_ANALISTA || isMONRL_ADMIN_CENTRAL || isMONRL_LANCAMENTO || isMONRL_ADMIN_SETORIAL);

  //   if (data.idenItemPai === "0") {
  //     history.push({
  //       pathname: "/avaliacao/programa",
  //       state: {
  //         data,
  //         parametroExercicio,
  //         podeAvaliarPrograma,
  //         podeAvaliarIndicador,
  //         podeAvaliarAcao,
  //         podeAnalisarPrograma,
  //         podeAnalisarIndicador,
  //       },
  //     });
  //   } else {
  //     history.push({
  //       pathname: "/avaliacao/acao",
  //       state: { data, parametroExercicio, podeAvaliarAcao, podeAnalisarAcao },
  //     });
  //   }
  // }

  const itemArvoreTemplate = (node, column) => {
    return (
      <span>
        {(node.tipoItem === "AÇÃO" ? "AÇÃO: " + node.codFiplanItem : "PROGRAMA: " + node.programa.codgPrograma) +
          " - " +
          node.descricaoItem}
      </span>
    );
  };

  const onChangeExercicio = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;
    setExercicioSelecionado(e.value);
    setOrgaoSelecionado(null);
    setUoSelecionada(null);
    setCDadosOrgaos(null);
    setCDadosUOs(null);
    if (e.value !== undefined) {
      montarArvore(null);
      await carregarArvoreRagComFiltro(
        {
          idenExercicio: e.value.idenExercicio,
          idenOrgao: null,
          idenUo: null,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((res) => {
        montarArvore(res);
      });
    }
  };

  const onChangeOrgao = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;
    setOrgaoSelecionado(e.value);
    setUoSelecionada(null);
    setCDadosUOs(null);
    setCDadosArvore([]);
    if (e.value !== undefined) {
      await carregarArvoreRagComFiltro(
        {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: e.value.idenOrgao,
          idenUo: null,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((dadosArvore) => {
        if (dadosArvore != null && dadosArvore.arvorePtaMonitoras != null) {
          carregarCronogramas(dadosArvore.parametroExercicio.idenParametroExercicio);
        } else {
          setParametroExercicio([]);
        }
        setCDadosUOs(dadosArvore != null ? dadosArvore.unidadeOrcamentarias : null);
      });
    }
  };

  const onChangeUo = async (e) => {
    let buscarArvoreGeral = isMONRL_ACESSO_ORGAO_CONTROLE || isMONRL_ADMIN_CENTRAL || isMONRL_ANALISTA;
    setUoSelecionada(e.value);
    setCDadosArvore(null);
    if (e.value !== undefined) {
      await carregarArvoreRagComFiltro(
        {
          idenExercicio: exercicioSelecionado.idenExercicio,
          idenOrgao: orgaoSelecionado.idenOrgao,
          idenUo: e.value.idenUo,
          idenPrograma: null,
        },
        defaultArvoreRag,
        buscarArvoreGeral
      ).then((res) => {
        montarArvore(res);
        let filtroPagina = {
          filtros: {
            namePagina: nomePagina,
            campos: [
              { key: "parametroExercicio", value: parametroExercicio },
              { key: "Exercicio", value: exercicioSelecionado },
              { key: "cDadosExercicios", value: cDadosExercicios },
              { key: "Orgao", value: orgaoSelecionado },
              { key: "cDadosOrgaos", value: cDadosOrgaos },
              { key: "UO", value: e.value },
              { key: "cDadosUOs", value: cDadosUOs },
              { key: "cDadosArvore", value: res.arvorePtaMonitoras },
              { key: "cronograma", value: cronograma },
            ],
          },
        };
        dispatch({ type: "setFiltros", value: filtroPagina });
      });
    }
  };
  useEffect(() => {
    if (filtroReducer.filtros.length > 1) {
      var carregaFiltros = filtroReducer.filtros.find((item) => {
        if (item.filtros !== undefined) {
          if (item.filtros.namePagina === "Lancamentos RAG");
          return item;
        }
      });
    }

    if (user) {
      if (carregaFiltros !== undefined) {
        for (const campo of carregaFiltros.filtros.campos) {
          if (campo.key === "parametroExercicio") {
            setParametroExercicio(campo.value);
          }
          if (campo.key === "Exercicio") {
            setExercicioSelecionado(campo.value);
          }
          if (campo.key === "Orgao") {
            setOrgaoSelecionado(campo.value);
          }
          if (campo.key === "UO") {
            setUoSelecionada(campo.value);
          }
          if (campo.key === "cDadosExercicios") {
            setCDadosExercicios(campo.value);
          }
          if (campo.key === "cDadosOrgaos") {
            setCDadosOrgaos(campo.value);
          }
          if (campo.key === "cDadosUOs") {
            setCDadosUOs(campo.value);
          }
          if (campo.key === "cDadosArvore") {
            setCDadosArvore(campo.value);
          }
          if (campo.key === "cronograma") {
            setCronograma(campo.value);
          }
        }
        //carregarLancamentoComFiltro({ idenExercicio, idenOrgao, idenUo });
      } else {
        carregarLancamentoSemFiltro();
      }
    }
  }, []);

  const saveHistoryFilter = ({
    parametroExercicio,
    exercicioSelecionado,
    uoSelecionada,
    cDadosExercicios,
    orgaoSelecionado,
    cDadosOrgaos,
    cDadosUOs,
    cDadosArvore,
    cronograma,
  }) => {
    let filtroPagina = {
      filtros: {
        namePagina: "Lancamentos RAG",
        campos: [
          { key: "parametroExercicio", value: parametroExercicio },
          { key: "Exercicio", value: exercicioSelecionado },
          { key: "cDadosExercicios", value: cDadosExercicios },
          { key: "Orgao", value: orgaoSelecionado },
          { key: "cDadosOrgaos", value: cDadosOrgaos },
          { key: "UO", value: uoSelecionada },
          { key: "cDadosUOs", value: cDadosUOs },
          { key: "cDadosArvore", value: cDadosArvore },
          { key: "cronograma", value: cronograma },
        ],
      },
    };
    dispatch({ type: "setFiltros", value: filtroPagina });
  };

  return (
    <CardSeplag title={"RELATÓRIO ANUAL DE GESTÃO : LANÇAMENTO DE DADOS"}>
      <div className="p-fluid grid line-height-4">
        <div className="field col-12 md:col-9 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <span>
                <label htmlFor="selExercicio">Exercício</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selExercicio"
                  value={exercicioSelecionado}
                  options={cDadosExercicios}
                  onChange={onChangeExercicio}
                  optionLabel="ano"
                  filter
                  showClear
                  filterBy="ano"
                  placeholder="Selecione um exercício"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selOrgao">Órgão</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selOrgao"
                  value={orgaoSelecionado}
                  options={cDadosOrgaos}
                  onChange={onChangeOrgao}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione um Órgão"
                />
              </span>
            </div>
            <div className="field col-12 md:col-4">
              <span>
                <label htmlFor="selUO">U.O</label>
                <Dropdown
                  emptyMessage="Dados não encontrados"
                  emptyFilterMessage="Opção não encontrada"
                  id="selUO"
                  value={uoSelecionada}
                  options={cDadosUOs}
                  onChange={onChangeUo}
                  optionLabel="descricaoFiplan"
                  filter
                  showClear
                  filterBy="descricaoFiplan"
                  placeholder="Selecione uma U.O."
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="card">
          <TreeTable
            emptyMessage="Dados não encontrados"
            value={cDadosArvore && cDadosArvore.content ? cDadosArvore.content : []}
          >
            <Column body={acoesTemplate} style={{ textAlign: "center", width: "8%" }} header="Ações" />
            <Column
              field="descricaoItem"
              body={itemArvoreTemplate}
              style={{ textAlign: "justify", width: "98%" }}
              expander
              header="Descrição"
            />
          </TreeTable>
        </div>
      </div>
    </CardSeplag>
  );
};

export default RagLancamentos;
